import {
	Component,
	Input,
	OnDestroy,
	OnInit,
	Signal,
	ViewEncapsulation,
	WritableSignal,
	signal,
} from '@angular/core';
import { FormGroup, UntypedFormBuilder } from '@angular/forms';

interface Scope {
	loading: WritableSignal<boolean>;
}

@Component({
	selector: 'ms-input-switch',
	templateUrl: './ms-input-switch.component.html',
	styleUrls: ['./ms-input-switch.component.scss'],
	encapsulation: ViewEncapsulation.None,
	standalone: false,
})
export class MsInputSwitchComponent implements OnInit, OnDestroy {
	@Input() formGroup: FormGroup;
	@Input() trueValue: any | null;
	@Input() falseValue: any | null;
	@Input() readonly: boolean | null;
	@Input() disabled: boolean | null;
	@Input() styleClass: string | null;
	@Input() onChange: (...args: any) => void;
	@Input() data: any | null;
	@Input() value: any | null;
	@Input() title: string;
	@Input() key: string;

	scope: Scope = {
		loading: signal(true),
	};

	/**
	 * Constructor
	 */
	constructor(private _formBuilder: UntypedFormBuilder) {}

	// -----------------------------------------------------------------------------------------------------
	// @ Lifecycle hooks
	// -----------------------------------------------------------------------------------------------------

	/**
	 * On init
	 */
	ngOnInit(): void {
		if (!this.formGroup) {
			this.formGroup = this._formBuilder.group({
				name: [null, []],
			});
			this.key = 'name';
			this.formGroup.get(this.key).setValue(this.value);
		} else if (!this.value) {
			this.value = this.formGroup.get(this.key).value;
		}
		if (this.trueValue === undefined) {
			this.trueValue = true;
		}
		if (this.falseValue === undefined) {
			this.falseValue = false;
		}
		if (this.onChange === undefined) {
			this.onChange = () => {};
		}
		this.scope.loading.set(false);
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {}

	// -----------------------------------------------------------------------------------------------------
	// @ Public methods
	// -----------------------------------------------------------------------------------------------------

	onChangeCallback(event: any): void {
		this.onChange(this.data, event.checked);
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Private methods
	// -----------------------------------------------------------------------------------------------------
}
